export default {
  auditReport: {
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    all: 'All',
    exportSuccess: 'Export successful',
    exportError: 'Export failed',
    fetchError: 'Query failed',
    summary: {
      dateRange: 'Date Range (+8)',
      dateRequired: 'Please select date range',
      reportDate: 'Report Date',
      branch: 'Branch',
      bet: 'Bet',
      payout: 'Payout',
      ggr: 'GGR',
      headcountOfActive: 'Headcount Of Active',
      totalBet: 'Total Bet',
      totalPayout: 'Total Payout',
      totalGgr: 'Total GGR',
      totalActiveHc: 'Active Player HC',
    },
    gameType: {
      dateRange: 'Date Range (+8)',
      dateRequired: 'Please select date range',
      reportDate: 'Report Date',
      gameType: 'Game Type',
      bet: 'Bet',
      payout: 'Payout',
      ggr: 'GGR',
    },
    branchGameType: {
      dateRange: 'Date Range (+8)',
      dateRequired: 'Please select date range',
      reportDate: 'Report Date',
      branch: 'Branch',
      gameType: 'Game Type',
      bet: 'Bet',
      payout: 'Payout',
      ggr: 'GGR',
    },
    provider: {
      dateRange: 'Date Range (+8)',
      dateRequired: 'Please select date range',
      reportDate: 'Report Date',
      provider: 'Provider',
      gameType: 'Game Type',
      betCount: 'Total Transaction Count',
      bet: 'Bet',
      payout: 'Payout',
      ggr: 'GGR',
      total: 'Total',
    },
    providerGameType: {
      dateRange: 'Date Range (+8)',
      dateRequired: 'Please select date range',
      reportDate: 'Report Date',
      provider: 'Game Provider',
      gameType: 'Game Type',
      platformType: 'Platform Type',
      betCount: 'Total Transaction Count',
      bet: 'Bet',
      payout: 'Payout',
      ggr: 'GGR',
      total: 'Total',
    },
    gameOrder: {
      betTimeRange: 'Bet Time',
      dateRequired: 'Please select bet time range',
      dateRangeMaxDays: 'Date range cannot exceed {{days}} days.',
      providerFilter: 'Provider',
      betId: 'Bet ID',
      betIdPlaceholder: 'Enter Bet ID',
      partnerOrderId: 'Partner Order ID',
      flowIdPlaceholder: 'Enter Partner Order ID',
      userId: 'User ID',
      userIdPlaceholder: 'Enter User ID',
      userName: 'User Name',
      memberAccountPlaceholder: 'Enter exact User Name',
      channelType: 'Channel Type',
      outletId: 'Outlet ID',
      gameName: 'Game Name',
      gameType: 'Game Type',
      provider: 'Provider',
      platformType: 'Platform Type',
      platformCode: 'Platform Code',
      gameId: 'Game ID',
      gameIdPlaceholder: 'Enter Game ID',
      before: 'Before',
      after: 'After',
      bet: 'Bet',
      validBets: 'Valid Bets',
      payouts: 'Payouts',
      winLose: 'Win/Lose',
      refund: 'Refund',
      ggr: 'GGR',
      isBuyFeature: 'isBuyFeature',
      result: 'Result',
      status: 'Status',
      betTime: 'Bet Time',
      settlementTime: 'Settlement Time',
      detail: 'Operation',
      viewDetail: 'View Detail',
      sportDetail: 'Sport Detail',
      casinoDetail: 'Casino Detail',
      detailField: {
        // fallback basic info
        game_name: 'Game Name',
        game_id: 'Game ID',
        game_brand: 'Game Brand',
        game_type: 'Game Type',
        // casino detail (PAGCOR)
        liveGameRound: 'Live Game Round',
        jackpotContribution: 'Jackpot Contribution',
        jackpotPayout: 'Jackpot Payout',
        houseRake: 'House Rake',
        rakeCeiling: 'Rake Ceiling',
        blinds: 'Blinds',
        netWin: 'Net Win',
        // sports event extra info (SportEventExtInfo)
        sportName: 'Sport',
        leagueName: 'League',
        eventName: 'Event',
        matchDateTime: 'Match Time',
        handicap: 'Handicap',
        odds: 'Odds',
        finalScore: 'Final Score',
        itemStatus: 'Item Status',
        settlementStatus: 'Settlement Status',
        isLive: 'Live',
        yes: 'Yes',
        no: 'No',
      },
    },
    playerCount: {
      dateRange: 'Date Range (+8)',
      dateRequired: 'Please select date range',
      reportDate: 'Report Date',
      dailyRegisteredHc: 'Daily Registered HC',
      dailyKycVerifiedHc: 'Daily KYC Verified HC',
      dailyKycPendingHc: 'Daily KYC Pending/Processing HC',
      activeHc: 'Active HC',
      deactivatedHc: 'Deactivated/Inactive HC',
    },
    playerAggregator: {
      dateRange: 'Date Range (+8)',
      dateRequired: 'Please select date range',
      reportDate: 'Report Date',
      memberAccount: 'Member Account',
      playerIdPlaceholder: 'Exact match',
      outletId: 'Outlet ID',
      channelType: 'Channel Type',
      pageTotal: 'Page Total',
      depositCount: 'Deposit Count',
      depositAmount: 'Deposit Amount',
      withdrawCount: 'Withdrawal Count',
      withdrawAmount: 'Withdrawal Amount',
      totalBetAmount: 'Total Bet Amount',
      totalPayoutAmount: 'Total Payout Amount',
      winLoseAmount: 'Win/Lose Amount',
    },
  },
};
